<div class="feedback-container">
  <h2>{{ message }}</h2>
</div>